"use client";

import React from 'react';

export default function Hero() {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <header className="hero-stage relative overflow-hidden">
      <div className="max-w-screen-2xl mx-auto px-8 pt-16 pb-24 md:pt-20 md:pb-28 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-x-2 rounded-3xl bg-zinc-900 px-4 py-1 text-sm mb-6 border border-zinc-800">
            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
            <span className="text-emerald-400 font-medium">Działamy 24/7 • Wsparcie techniczne</span>
          </div>

          <h1 className="text-6xl md:text-7xl font-semibold tracking-tighter leading-none mb-6">
            Bezpieczeństwo<br />
            <span className="text-white">pod pełną kontrolą.</span>
          </h1>

          <p className="max-w-lg text-xl text-zinc-400 mb-10">
            DaHaka Inc. projektuje i wdraża zaawansowane systemy monitoringu wizyjnego 
            dla firm, magazynów, obiektów użyteczności publicznej i instytucji.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="tel:+48661709414"
              className="group flex items-center justify-center gap-x-3 px-8 py-4 bg-blue-600 hover:bg-blue-500 active:bg-blue-700 transition-colors text-lg font-semibold rounded-3xl"
            >
              <span>☎ Zadzwoń: 661 709 414</span>
            </a>
            <button
              onClick={() => scrollTo('kontakt')}
              className="flex items-center justify-center gap-x-3 px-8 py-4 bg-white text-zinc-950 hover:bg-zinc-100 font-semibold rounded-3xl transition-colors"
            >
              Bezpłatna wycena w 24h
            </button>
          </div>

          <div className="flex items-center gap-x-8 mt-12 text-sm">
            <div className="flex -space-x-2">
              <div className="w-8 h-8 bg-zinc-700 rounded-full ring-2 ring-zinc-950 overflow-hidden">
                <img src="https://i.pravatar.cc/32?img=28" alt="" className="w-full h-full object-cover" />
              </div>
              <div className="w-8 h-8 bg-zinc-700 rounded-full ring-2 ring-zinc-950 overflow-hidden">
                <img src="https://i.pravatar.cc/32?img=47" alt="" className="w-full h-full object-cover" />
              </div>
              <div className="w-8 h-8 bg-zinc-700 rounded-full ring-2 ring-zinc-950 overflow-hidden">
                <img src="https://i.pravatar.cc/32?img=12" alt="" className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="text-zinc-400">
              <span className="font-medium text-zinc-300">+180 klientów</span><br />
              <span className="text-xs">zaufało nam w 2024 roku</span>
            </div>
          </div>
        </div>

        <div className="cam-frame hidden lg:block">
          <div className="radar" />
          <div className="radar-sweep" />
          <div className="scanline" />
          <div className="absolute top-5 left-5 right-5 flex items-center justify-between text-xs font-medium tracking-wide">
            <span className="flex items-center gap-2 text-red-400">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
              REC
            </span>
            <span className="text-sky-200/80">CAM 01 · KUTNO</span>
          </div>
          <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between text-xs text-zinc-300">
            <div>
              <div className="text-sky-300 font-semibold">Podgląd na żywo</div>
              <div className="text-zinc-400">ul. Piątkowska 8 · 4K · IR</div>
            </div>
            <div className="rounded-full border border-sky-400/30 bg-sky-400/10 px-3 py-1 text-sky-200">
              Noktowizja ON
            </div>
          </div>
        </div>
        </div>
      </div>
    </header>
  );
}
